import { render, staticRenderFns } from "./player-volume.vue?vue&type=template&id=40acb1c0&scoped=true&"
import script from "./player-volume.vue?vue&type=script&lang=ts&"
export * from "./player-volume.vue?vue&type=script&lang=ts&"
import style0 from "./player-volume.vue?vue&type=style&index=0&id=40acb1c0&lang=stylus&scoped=true&"
import style1 from "./player-volume.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40acb1c0",
  null
  
)

export default component.exports